import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import About from './pages/About'
import Contact from './pages/Contact'
import Tools from './pages/Tools'
import ToolDetail from './pages/ToolDetail'

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/tools/:category" element={<ToolDetail />} />
          <Route path="/tools/:category/:toolName" element={<ToolDetail />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App

